import styled from '@emotion/styled/macro';
import { BaseButton } from '../button';
import { Variables } from '../variables';

/** Moved verbatim from the patient statement's tab bar, so that screen renders exactly as before. */

export const Tabs = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    border-bottom: 1px solid ${Variables.Colors.n30};
`;

export const Tab = styled(BaseButton)<{ $active?: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 7px;
    height: 40px;
    padding: 0 4px;
    margin-right: 20px;
    margin-bottom: -1px;
    min-width: auto;
    border-radius: 0;
    border: none;
    border-bottom: 2px solid ${props => (props.$active ? Variables.Colors.b300 : 'transparent')};
    font-size: 15px;
    font-weight: ${props => (props.$active ? 600 : 500)};
    line-height: 1;
    color: ${props => (props.$active ? Variables.Colors.n100 : Variables.Colors.n70)};
    background: transparent;
    outline: none;
    user-select: none;

    &:hover:not(:disabled) {
        color: ${Variables.Colors.n100};
        background: transparent;
    }

    &:focus-visible {
        outline: 2px solid ${Variables.Colors.b300};
        outline-offset: -2px;
    }
`;

export const CountWrap = styled.span`
    display: inline-flex;
`;
